import { HubConnection, HubConnectionState } from '@microsoft/signalr';
import { createAsyncThunk } from '@reduxjs/toolkit';

export interface SendMessageThunkArg {
    connection: HubConnection;
    clubhouseId: number;
    messageText: string;
    selectedDiscussionId: number;
    attachmentsIds: Array<number>;
    sharedContentIds: Array<number>;
}

export const sendMessage = createAsyncThunk(
    'clubhouseMessages/send',
    async (arg: SendMessageThunkArg, thunkApi) => {
        const chatMessage = {
            clubhouseId: arg.clubhouseId,
            discussionId: arg.selectedDiscussionId,
            htmlContent: arg.messageText,
            attachmentsIds: arg.attachmentsIds,
            sharedContentIds: arg.sharedContentIds,
        };
        // Use invoke (not fire-and-forget send): invoke waits for the server to
        // acknowledge the message, so a send that never reaches the server -- e.g.
        // a half-open socket where connection.state still reports Connected --
        // rejects instead of vanishing silently. The caller restores the composer
        // and notifies the user on rejection. A server-side rejection is caught by
        // the hub and reported via CL_ClubhouseActionFailed, so invoke still
        // resolves in that case (no double handling).
        if (arg.connection?.state !== HubConnectionState.Connected) {
            return thunkApi.rejectWithValue('not-connected');
        }
        try {
            await arg.connection.invoke('CL_SendMessage', chatMessage);
        } catch {
            return thunkApi.rejectWithValue('send-failed');
        }
    }
);
